import React, { Component } from "react";
import { Skeleton } from "antd";
import Axios from "../../../config/axios";
import styles0 from "assets/jss/material-kit-react/views/landingPage.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import InputAdornment from "@material-ui/core/InputAdornment";
import Search from "@material-ui/icons/Search";
import classNames from "classnames";
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import withErrorHandler from "hoc/withErrorHandler";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import {
  cardTitle,
  cardLink,
  cardSubtitle,
} from "assets/jss/material-kit-react.js";
import { Link } from "react-router-dom";

const styles = {
  ...styles0,
  cardTitle,
  cardLink,
  cardSubtitle,
};

class ListLetters extends Component {
  state = {
    letters: [],
    loading: true,
    searchText: "",
  };

  componentDidMount() {
    this.fetchLetters();
  }

  handleSearch = (e) => {
    this.setState({ searchText: e.target.value });
  };

  fetchLetters = async() => {        
    let userMajor = {}
    try{
        const res = await Axios.get(`/faculty?nim=${this.props.user.identity}`)
        userMajor = res.data
    }catch(error){
        console.error(error)
    }

    Axios.get(`/letters?faculty_id=${userMajor.new_kode}`).then(response => {
        this.setState({ letters: response.data.payload, loading: false })
    })
}

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Parallax
          style={{ height: 200 }}
          filter
          image={require("assets/img/background.jpeg")}
        />
        <div className={classNames(classes.main, classes.mainRaised)}>
          <div className={classes.container}>
            <div className={classes.section} style={{ color: "#000" }}>
              <GridContainer justify="center">
                <h3 className={classes.title} style={{ color: "#000" }}>
                  Daftar Surat Permohonan
                </h3>
              </GridContainer>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={4}>
                  <CustomInput
                    labelText="Cari Surat..."
                    id="material"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Search />
                        </InputAdornment>
                      ),
                      onChange: this.handleSearch,
                      value: this.state.searchText,
                    }}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <Skeleton active={true} loading={this.state.loading}>
                  {this.state.letters.map((academic, index) => {
                    return academic.title
                      .toLowerCase()
                      .indexOf(this.state.searchText.toLowerCase()) !== -1 ? (
                      <GridItem xs={12} sm={12} md={3} key={index}>
                        {/* <InfoArea
                                                                title={academic.title}
                                                                description={academic.description || 'Tidak ada keterangan untuk surat ini.'}
                                                                icon={School}
                                                                iconColor="success"
                                                                vertical
                                                                link={"/ajukan-surat/"+academic._id}
                                                            /> */}
                        <Card>
                          <CardBody>
                            <h4 className={classes.cardTitle}>
                              {academic.title}
                            </h4>
                            <p>
                              {academic.description ||
                                "Tidak ada keterangan untuk surat ini."}
                            </p>
                            <Link
                              to={"/ajukan-surat/" + academic._id}
                              href="#pablo"
                              className={classes.cardLink}
                            >
                              Buat Ajuan
                            </Link>
                          </CardBody>
                        </Card>
                      </GridItem>
                    ) : null;
                  })}
                </Skeleton>
              </GridContainer>
            </div>
            {/* <div className={classes.section} style={{color:'#000'}}>
                            <GridContainer justify="center">
                                <h3 className={classes.title} style={{color:'#000'}}>Surat Kemahasiswaan</h3>                           
                            </GridContainer>
                            
                            <GridContainer>
                                <Skeleton active={true} loading={this.state.studentsLoading}>
                                        {
                                            this.state.students.map((student, index) => 
                                                <GridItem xs={6} sm={6} md={3} key={index}>
                                                    <InfoArea
                                                        title={student.title}
                                                        description={student.description || 'Tidak ada keterangan untuk surat ini.'}
                                                        icon={Group}
                                                        iconColor="success"
                                                        vertical
                                                        link={"/ajukan-surat/"+student._id}
                                                    />
                                                </GridItem>
                                            )
                                     }   
                                </Skeleton>
                            </GridContainer>
                        </div> */}
          </div>
        </div>
      </div>
    );
  }
}

ListLetters.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withErrorHandler(withStyles(styles)(ListLetters), Axios);
